import styled, { css } from 'styled-components'

const UploadField = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(0.75)};
  `}
`

const Button = styled.button`
  ${({ theme }) => css`
    width: 100%;
    padding: ${theme.spacing(3)};
    font-size: 1.8rem;
    border: 0.1rem dashed ${theme.palette.grey[500]};
    border-radius: ${theme.spacing(0.25)};
    background-color: ${theme.palette.grey[100]};
    text-align: center;

    &:hover {
      opacity: 0.75;
    }
  `}
`

const Message = styled.p`
  ${({ theme }) => css`
    font-size: 1.4rem;
    margin-top: ${theme.spacing(2)};
    margin-bottom: 0;
  `}
`

const Icon = styled.div`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    border-radius: 2rem;
    background-color: ${theme.palette.grey[300]};
  `}
`

const Preview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16rem;
  height: 16rem;
  overflow: hidden;
  border: 0.1rem solid rgba(0, 0, 0, 0.2);
  margin: auto;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const Spinner = styled.div`
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`

const Hint = styled.div`
  margin: 0.4rem 0 0.8rem;
`

export default {
  UploadField,
  Button,
  Icon,
  Message,
  Preview,
  Spinner,
  Hint,
}
